import * as Sentry from '@sentry/react';

const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;
const isValidDsn = Boolean(
  dsn && dsn.trim() !== '' && !dsn.includes('[EMAIL]') && dsn.startsWith('http'),
);
const sentryEnabled = import.meta.env.VITE_SENTRY_ENABLED === 'true';
const enabled = isValidDsn && sentryEnabled;

Sentry.init({
  dsn: isValidDsn ? dsn : undefined,
  enabled,
  environment: import.meta.env.MODE,
  release: 'dashboard@0.0.0',
  tracesSampleRate: 0.1,
  enableLogs: true,
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 1,
  integrations: [Sentry.consoleLoggingIntegration({ levels: ['log', 'warn', 'error'] })],
});

if (typeof window !== 'undefined' && enabled) {
  Sentry.setTag('platform', 'web');
}
